import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Rating } from 'react-simple-star-rating';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    textAlign: 'center',
    marginTop: '10px',
  },
  title: { textTransform: 'capitalize', fontSize: 20 },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '10px 0px',
  },
  stars: { marginRight: '10px' },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'lightgray',
    borderRadius: '10px',
    padding: '5px 10px',
  },
  contentBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px',
    paddingBottom: '10px !important',
  },
});

export default function RatingsCard({ activeRole, truckerData }) {
  const classes = useStyles();
  const rating = truckerData?.average_rating || 0;

  return (
    <Card className={classes.root}>
      <CardContent className={classes.contentBox}>
        <div className={classes.titleBox}>
          <Typography variant="h6" className={classes.title}>
            Overall Rating
          </Typography>
        </div>

        <div className={classes.flex}>
          <Rating
            emptyColor="white"
            initialValue={rating}
            size={40}
            allowFraction
            classNames={classes.stars}
            readonly
          />
          <Typography
            variant="caption"
            display="block"
            style={{ marginLeft: '10px' }}
          >
            {rating} out of 5
          </Typography>
        </div>
      </CardContent>
    </Card>
  );
}
